export default __webpack_public_path__ + "static/featured_image_og_codilime_SPE_cloud-20cadd5303035db5767ff90168b0eea3.jpg";